/**
 * Public-safe environment access.
 *
 * Vite exposes `import.meta.env.VITE_*` to client bundles. Anything not
 * prefixed with `VITE_` will not leak. Read all envs from this single
 * module so we have one place to guard / type them.
 */

export const env = {
  landingUrl: import.meta.env.VITE_LANDING_URL ?? "https://getcitizenai.com",
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? "en",
  // No VITE_API_BASE_URL: the SPA is served same-origin as the API in prod,
  // and the dev server proxies /v1/* to localhost:8080 (see vite.config.ts).
  apiBaseUrl: "" as const,
  // Closed-alpha switches.
  // VITE_ENABLE_GOOGLE_OAUTH: "true" → Google "Continue with Google"
  // button is enabled and the test-user form is hidden. Anything else
  // → button is disabled (Coming soon) and the test-user email form is
  // visible. Default off because alpha runs without real Google creds.
  googleOAuthEnabled: import.meta.env.VITE_ENABLE_GOOGLE_OAUTH === "true",
  // VITE_ALPHA_MODE: "true" → render the AlphaBanner site-wide after
  // login (warning that data may be wiped, packets aren't filing-ready).
  alphaMode: import.meta.env.VITE_ALPHA_MODE === "true",
};
